import { render, staticRenderFns } from "./EditPageItem.vue?vue&type=template&id=3d33db75&"
import script from "./EditPageItem.vue?vue&type=script&lang=js&"
export * from "./EditPageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports